/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import { Dimensions } from 'react-native';
import styled from 'styled-components/native';
// import { getScaledValue } from 'renative';
import Icons from './../assets/icons';

// Read window height LAZILY per call (not captured once at module load): on
// react-native-web the module evaluates before first layout, where
// Dimensions.get('window').height can be 0/undefined. A captured undefined makes
// getScaledValue() return NaN, and a styled `border: ${getScaledValue(2)}px ...`
// then emits `border: NaNpx ...` — an unparseable WORD token that crashes
// css-to-react-native ("Unexpected token type: word") and takes the whole TV
// React tree down the moment a card's focused border applies on D-pad nav
// (59-04: blocked T.4-T.12). Guard to a finite px so the value is always valid.
const FALLBACK_HEIGHT = 720; // 720p web baseline used when layout is not ready
const windowHeight = (): number => {
  const h = Dimensions.get('window').height;
  return typeof h === 'number' && Number.isFinite(h) && h > 0 ? h : FALLBACK_HEIGHT;
};
export const getScaledValue = (value: number) => {
  const scaled = value * (windowHeight() / 500);
  return Number.isFinite(scaled) ? scaled : 0;
};

export const hexToRgb = (hex: string) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    const n = parseInt(c.join(''), 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(',');
  }
  return `255,255,255`;
};

export const Logo = styled(Icons).attrs({
  icon: 'logo',
  width: getScaledValue(90),
  height: getScaledValue(90),
})``;

export const Load = styled.ActivityIndicator.attrs((p: { flat?: boolean }) => ({
  color: 'white',
  marginTop: p.flat ? 0 : getScaledValue(40),
}))``;
